import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import './style.css';

export default function ShippingPolicy() {
  return (
    <div className="shipping_policy_bg">
      <SEO {...pageSEO.shippingPolicy} />
      {/* Banner Section */}
      <div className="shipping_policy_banner"></div>

      {/* Main Policy Sections (New Content) */}
      <section className="shipping_policy_content">
        <h1>Shipping Policy</h1>
        <p>
          At <strong>Importerr.com</strong>, a brand of <strong>Boundless Trends Pvt. Ltd.</strong>, we are committed to delivering bulk orders across India in a safe and timely manner. This Shipping Policy explains how we process, dispatch, and deliver your orders.
        </p>
      </section>

      <section className="shipping_policy_content">
        <h2>1. Service Coverage</h2>
        <ul>
          <li>We currently provide shipping services <strong>across India</strong>.</li>
          <li>Deliveries are handled through our trusted logistics and courier partners.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>2. Order Processing</h2>
        <ul>
          <li>Orders are confirmed only after full payment or as per agreed terms.</li>
          <li>Dispatch timelines depend on the type and quantity of goods ordered which are mentioned at the time of placing the order.</li>
          <li>For bulk/customized orders, additional time may be required for packaging and handling.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>3. Shipping Time</h2>
        <ul>
          <li>Standard delivery timelines: <strong>7–10 business days</strong> (may vary based on location and product availability).</li>
          <li>Remote or difficult-to-reach areas may take longer.</li>
          <li>We will share tracking details with you (if available) once the order has been dispatched.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>4. Shipping Charges</h2>
        <ul>
          <li>Shipping charges are calculated based on order volume, weight, and delivery location.</li>
          <li>Any applicable charges will be communicated before finalizing the order.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>5. Delivery Guidelines</h2>
        <ul>
          <li>Customers are requested to ensure that delivery address and contact details are accurate and complete.</li>
          <li>Someone must be available to receive and verify the delivery at the shipping address.</li>
          <li>In case of unsuccessful delivery attempts due to incorrect address or unavailability, additional charges may apply for re-delivery.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>6. Damaged or Wrong Delivery</h2>
        <ul>
          <li>If products are received in <strong>damaged condition</strong> or if there is a <strong>wrong delivery</strong>, customers must notify us immediately within <strong>48 hours</strong> of delivery, along with photo/video proof.</li>
          <li>Upon verification, we will arrange for replacement or refund as per our <strong>Refund Policy</strong>.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>7. No Returns on Bulk Orders</h2>
        <ul>
          <li>Since customers are provided with <strong>demo products</strong> before placing bulk orders, returns are not accepted for bulk consignments, except in cases of damaged or incorrect delivery.</li>
        </ul>
      </section>

      <section className="shipping_policy_content">
        <h2>8. Contact Us</h2>
        <p>
          For shipping-related queries or to raise a claim, please <a href="mailto:contact@importerr.com" style={{ color: 'blue', textDecoration: 'underline' }}>contact@importerr.com</a>
        </p>
      </section>
    </div>
  );
}
